import React, { useRef, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { apiPatch } from '~/util/api'
import { Button } from '~/lib/ui/button'
import { PaperClipIcon } from '@heroicons/react/24/outline'
import RichTextEditor from '~/lib/ui/rich-text-editor'
import { useMessaging } from './MessagingProvider'
import useTranslation from '../shared/TranslationProvider'

const ThreadReply = ({ setReplying }) => {
  const { t } = useTranslation('CoachMessageThread')
  const editorRef = useRef(null)
  const attachmentRef = useRef(null)
  const [fileName, setFileName] = useState(null)
  const { currentThreadId, queryClient, userIsCoach } = useMessaging()

  const cancelReply = () => {
    setReplying(false)
  }

  const patchReply = async (form) => {
    const patchPath = `${window.location.pathname}/${currentThreadId}.json`
    const res = await apiPatch(patchPath, form, true)
    return res
  }

  const sendReplyMutation = useMutation({
    mutationFn: (form) => patchReply(form),
    onSuccess: () => {
      cancelReply()
      queryClient.invalidateQueries(['messageThreads', currentThreadId])
      editorRef.current.setContents([])
      return true
    },
  })

  const { isPending } = sendReplyMutation

  const sendReply = () => {
    const attachment = attachmentRef.current?.files[0]
    const body = editorRef.current.getSemanticHTML()

    const form = new FormData()
    form.append('coach_message_thread_reply[body]', body)
    form.append('coach_message_thread_reply[user_is_coach]', userIsCoach)
    if (attachment) {
      form.append('coach_message_thread_reply[attachment]', attachment)
    }

    sendReplyMutation.mutate(form)
  }

  const acceptFileTypes = ['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.doc']

  const onFileSelect = (event) => {
    const file = event.target.files[0]
    if (file) {
      setFileName(file.name)
    }
  }

  return (
    <>
      <div className="pt-4">
        <RichTextEditor ref={editorRef} />
      </div>
      <div className="mt-4 flex flex-row justify-end gap-x-4">
        {typeof setReplying === 'function' && (
          <Button variant="outline" onClick={cancelReply} disabled={isPending}>
            {t('cancel')}
          </Button>
        )}
        <div>
          <Button
            variant="outline"
            onClick={() => {
              attachmentRef.current.click()
            }}
            disabled={isPending}
          >
            <PaperClipIcon className="mr-1 h-5" />
            {fileName ? fileName : t('attach_file')}
          </Button>
          <input
            ref={attachmentRef}
            type="file"
            id="attachment-uploader"
            accept={acceptFileTypes}
            style={{ display: 'none' }}
            onChange={onFileSelect}
            disabled={isPending}
          />
        </div>
        <Button variant="coachcta" onClick={sendReply} disabled={isPending}>
          {t('reply')}
        </Button>
      </div>
    </>
  )
}
export default ThreadReply
